import { render } from "./CustomerLoader.vue?vue&type=template&id=02a526c2&ts=true"
import script from "./CustomerLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerLoader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__